import { usdcContractAddress } from "@talentir/shared/abis/erc-20";
import Big from "big.js";
import { getAddress } from "viem";

type Path = {
    currency?: string;
    currencyDecimals?: number;
    quantity?: number;
    totalRawPrice?: string;
};

export function getCostForQuantityGeneric(path: Path[], quantity: bigint) {
    let remainingQuantity = quantity;
    let totalCost = 0n;
    let decimals: number | undefined;

    for (const order of path) {
        if (remainingQuantity <= 0n) {
            break;
        }

        // only use USDC orders
        if (order.currency == null || getAddress(order.currency) !== usdcContractAddress) {
            continue;
        }

        decimals = order.currencyDecimals;

        const orderQuantity = BigInt(order.quantity ?? "0");
        const costOneToken = BigInt(order.totalRawPrice ?? "0");

        if (orderQuantity <= remainingQuantity) {
            const cost = costOneToken * orderQuantity;
            remainingQuantity -= orderQuantity;
            totalCost += cost;
        } else {
            const cost = costOneToken * remainingQuantity;
            remainingQuantity = 0n;
            totalCost += cost;
        }
    }

    if (remainingQuantity > 0) {
        return;
    }

    return {
        totalRawCost: totalCost,
        totalCost: Big(totalCost.toString())
            .div(Big(10).pow(decimals ?? 0))
            .toString(),
    };
}

export function getQuantityUpToCostGeneric(path: Path[], cost: bigint) {
    let remainingCost = cost;
    let totalQuantity = 0n;

    for (const order of path) {
        if (remainingCost <= 0n) {
            break;
        }

        // only use USDC orders
        if (order.currency == null || getAddress(order.currency) !== usdcContractAddress) {
            continue;
        }

        const orderQuantity = BigInt(order.quantity ?? "0");
        const costOneToken = BigInt(order.totalRawPrice ?? "0");
        const orderTotalCost = costOneToken * orderQuantity;

        if (orderTotalCost <= remainingCost) {
            remainingCost -= orderTotalCost;
            totalQuantity += orderQuantity;
        } else {
            const quantity = remainingCost / costOneToken;
            remainingCost = 0n;
            totalQuantity += quantity;
        }
    }

    if (remainingCost > 0) {
        return;
    }

    return totalQuantity;
}
